//封裝axios跟api接口設定
import axios from 'axios';
import store from './store';
import router from './router'

const service = axios.create({
  // baseURL: 'http://192.168.10.33/vendor/api/',
  // baseURL: '/visit/api/',
  // withCredentials: true,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
  timeout: 1000 * 600,//600秒
})

//設定開發網域與正式網域不同
// if (process.env.NODE_ENV === 'production') {
//   service.defaults.baseURL = '/vendor/api/'
// } else {
//   service.defaults.baseURL = 'http://192.168.10.33/vendor/api/'
// }


//request攔截器
service.interceptors.request.use(
  config => {
    //接收api都要帶token的選項
    // config.withCredentials = true
    // store.commit('loadingAction',true);
    if (store.state.user.token) {
      config.headers["Authorization"] = `Bearer ${store.state.user.token}`;
    }
    return config;
  },
  error => {
    // 判斷是否有異常，如果axios.isCancel==true，代表終止請求
    if (axios.isCancel(error)) {
      // 取消，說明原因
      console.warn(error)
      console.table([error.message.split('---')[0]], 'cancel')
    }
    return Promise.reject(error);
  }
)
//beforeRouter (to:要跳轉的頁面, from:從哪個頁面轉過來, next:執行下一個事件，每個判斷都必須確保使用到 next())
router.beforeEach((to, from, next) => {
  if (to.matched.length == 0 && process.env.NODE_ENV === 'production') {
    next({
      path: '/error'
    })
  } else {
    //判斷該頁面是否需要登入
    if (to.meta.requireAuth) {
      //判斷是否登入，是否具有token
      if (store.state.user.token) {
        //判斷身份
        if (store.state.user.role == 'vendor') {
          //設定只能前往承攬商業面跟錯誤頁面
          if (to.meta.role.includes('contractor')) {
            //判斷此頁面是否需要經過審核
            if (to.meta.pass) {
              //判斷承攬商是否通過審核
              if (store.state.user.isPass === 2) {
                //審核通過
                next()
              } else {
                alert("目前沒有權限訪問")
                next({
                  path: '/contractor/registered',
                })
              }
            } else {
              next()
            }
          }
          else if (process.env.NODE_ENV === 'production') {
            next({
              path: '/error'
            })
          } else {
            console.error('404')
          }
        }
        else if (store.state.user.role == 'manager') {
          if (to.meta.role.includes('manager')) {
            next()
          }
          else if (process.env.NODE_ENV === 'production') {
            next({
              path: '/error'
            })
          }
        }
        else if (store.state.user.role == 'department') {
          if (to.meta.role.includes('department')) {
            next()
          }
          else if (process.env.NODE_ENV === 'production') {
            next({
              path: '/error'
            })
          }
        }
      } else {
        console.log("是否有token", '沒有token')
        //沒有登入
        alert("沒有權限訪問")
        store.commit("removeToken"); //執行store內的function removeToken()

        next({
          path: '/',
          query: { redirect: to.fullPath }//轉址
        })
      }
    } else {
      //判斷狀態是否已經登入
      //如果是的話，不需要再進入註冊頁面或登入頁面，直接導回首頁
      if (store.state.user.token) {
        if (to.name === 'landingpage' || to.name === 'registered') {
          //判斷帳戶類型:
          if (store.state.user.role == 'vendor') {
            next({
              path: '/contractor'
            })
          } else if (store.state.user.role == 'manager') {
            next({
              path: '/admin'
            })
          } else if (store.state.user.role == 'department') {
            next({
              path: '/department'
            })
          }
        }
      }
      next();

    }
  }
})


//response攔截器
service.interceptors.response.use(
  res => {
    // store.commit('loadingAction',false);
    if (res.data.token) {
      localStorage.setItem("picker_token", res.data.token)
    }
    return res;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 404:
          console.log("404,找不到頁面");
          break;
        case 500:
          console.log("500,伺服器出錯");
          alert(`${error.response.status}_${error.response.data.message}`)
          break;
        case 503:
          console.log("503,服務失效");
          alert(`${error.response.status}_${error.response.data.message}`)
          break;
        case 401:
          console.log("沒有登入")
          if (error.response.data.message == "Unauthenticated.") {
            if (store.state.user.token) {
              alert("請重新登入")
              store.commit("removeToken")
              router.replace({
                path: '/'
              })
            } else {
              store.commit("removeToken")
              router.replace({
                path: '/'
              })
            }
          }

          break;
        default:
          console.log(`錯誤代碼:${error.response.status}`)

      }
    }
    // store.commit('loadingAction',false);
    return Promise.reject(error)
  }
)






//封裝出去到Vue的原型鏈上做使用
// export default {
//   install: function (Vue, option) {
//     Object.defineProperty(Vue.prototype, "$http", { value: service })
//   }

// }

export default service;